import styled from '@emotion/styled';

export const ContentSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 32px;
  width: 100%;
  padding: 0 16px;
`;

export const Heading = styled.div`
  font-family: 'Lora', serif;
  font-weight: 400;
  font-size: 28px;
  line-height: 1.2;
  text-align: center;
  color: #5e84ed;
`;

export const SubHeading = styled.div`
  font-family: Inter, sans-serif;
  font-weight: 400;
  font-size: 16px;
  line-height: 1.4;
  text-align: center;
  color: #b7bdcb;
  max-width: 344px;
`;

export const ScanLabel = styled.div`
  font-family: Inter, sans-serif;
  font-weight: 400;
  font-size: 17px;
  line-height: 1.4;
  text-align: center;
  color: #b7bdcb;
`;

export const QrContainer = styled.div`
  background: #fff;
  border-radius: 12px;
  padding: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const BadgesRow = styled.div`
  display: flex;
  gap: 32px;
  align-items: center;
  justify-content: center;
  padding-top: 32px;
`;

export const StoreBadge = styled.img`
  height: 35px;
  cursor: pointer;
`;

export const DownloadButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  width: 100%;
  max-width: 340px;
  padding: 16px 24px;
  border-radius: 12px;
  border: none;
  background: #fff;
  color: #1a1a1c;
  font-family: Inter, sans-serif;
  font-weight: 600;
  font-size: 16px;
  cursor: pointer;

  &:active {
    opacity: 0.85;
  }
`;

export const DownloadIcon = styled.img`
  width: 24px;
  height: 24px;
`;

export const ContinueOnWebButton = styled.button`
  width: 100%;
  max-width: 340px;
  padding: 16px 24px;
  border-radius: 12px;
  border: none;
  background: #5e84ed;
  color: #fff;
  font-family: Inter, sans-serif;
  font-weight: 600;
  font-size: 16px;
  cursor: pointer;
  margin-top: 16px;

  &:active {
    opacity: 0.85;
  }
`;
